import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicMinimizationDFA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Minimization of DFA"
      videos={[
        "https://www.youtube.com/embed/OBIA7YQIbq4",
        "https://www.youtube.com/embed/rGxyc-CJGRk",
      ]}
      takeaways={[
        { text: "Understand the equivalence or partition method for DFA minimization." },
        { text: "Learn the table-filling method and Myhill-Nerode theorem for DFA minimization." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicMinimizationDFA };
